<template>
	<Dialog>
		Please insert the Floppy labeled `{{floppy}}` in Drive A:\
	</Dialog>
</template>

<script>
	import { Component, Vue, Prop } from 'vue-property-decorator';
    import Dialog from '../../components/Dialog';
	import KeyListenerView from '../KeyListenerView';
	import SoundManager from '../../util/soundManager.js';

	@Component({
		components: {
			Dialog,
		},
	})
	export default class FloppyComponent extends KeyListenerView {
    	@Prop(String) floppy;

        mounted() {
			this.addKeyboardListener('ESC', this.onBackKey, 'Back');
			this.addKeyboardListener('BACKSPACE', this.onBackKey);
			super.mounted();
	
			SoundManager.play('beep2');
		}

		destroyed() {
			super.destroyed();
		}

		onBackKey() {
			this.$router.go(-1);
		}
	}
</script>

<style lang="scss">

</style>